null


// WEBPACK FOOTER //
// /Volumes/workplace/commands/GetTextDetectionCommand.ts